import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WhyActNow from "../components/WhyActNow";
import Priorities from "../components/Priorities";
import AwardCategories from "../components/AwardCategories";
import NominationGuide from "../components/NominationGuide";
import JuryPanel from "../components/JuryPanel";
import RegisterForm from "../components/RegisterForm";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FAF9F5] text-[#0f2a20]">
      <Header />
      <main>
        <Hero />
        <WhyActNow />
        <Priorities />
        <AwardCategories />
        <NominationGuide />
        <JuryPanel />
        <RegisterForm />
      </main>
      <Footer />
    </div>
  );
}
